import { useWindowSize } from '@react-hookz/web';
import { useEffect, useState } from 'react';

import { closeMobileMenu } from 'layout/header/store';

const useStopBodyScroll = (open: boolean) => {
  const { width } = useWindowSize();
  const [headerOffset, setHeaderTop] = useState(0);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : 'unset';
  }, [open]);

  const handleSetClosedMenu = () => {
    const header = document.querySelector('header');
    if (header) {
      const headerRect = header.getBoundingClientRect();
      setHeaderTop(headerRect.top + headerRect.height);
    }
    if (open && width > 1279) {
      closeMobileMenu();
    }
  };

  useEffect(() => {
    handleSetClosedMenu();
  }, [width]);

  return [headerOffset] as const;
};

export default useStopBodyScroll;
